const DataSearch = () => {
  return <div data-testid="data-search" />
}

export default DataSearch
